import { NoFound404 } from 'ui/temp'

import * as SC from './styles'

export const NotFound = () => (
  <SC.Box>
    <NoFound404 />
  </SC.Box>
)
